import { useCallback } from 'react';
import { UserAttribute } from '../../models/UserAttribute';
import { useHttpFetchApi } from '../http/useHttpFetch';

export function useSaveUserAttributes() {
  const { loading, error, postJson } = useHttpFetchApi();
  const saveUserAttributes = useCallback(
    async (userId: number, userAttribute: UserAttribute[]) => {
      return postJson<UserAttribute>(
        `users/${userId}/attributes`,
        userAttribute
      );
    },
    [postJson]
  );

  return {
    savingUserAttributes: loading,
    saveUserAttributesError: error,
    saveUserAttributes
  };
}
